import { blankCharacterRegex } from '../resources/regex-validators';
import { AbstractControl } from '@angular/forms';

export function blankCharacterValidation(control: AbstractControl): {[key: string]: boolean} | null {
  const correct = control.value?.match(blankCharacterRegex);
  return correct ? {blankCharacterString: true} : null;
}
